<script lang="ts">
  import type { VideoData, VideoOptions } from './video-player.svelte';
  import VideoPlayer from './video-player.svelte';

  type VideoType = 'video' | 'youtube';
  interface NormalVideoData {
    type: 'video';
    sources: {
      src: string;
      type: string;
    }[];
  }

  interface YoutubeVideoData {
    type: 'youtube';
    id: string;
  }

  export let videoType: VideoType;
  export let src: string; // URL for regular videos, id for YouTube
  export let posterUrl: string;

  let videoData: VideoData;
  let options: VideoOptions;

  $: videoData =
    videoType === 'video'
      ? {
          // Normal video data
          type: 'video',
          sources: [
            {
              src,
              type: 'application/x-mpegURL',
            },
          ],
        }
      : {
          // Youtube data
          type: 'youtube',
          id: src,
        };

  $: options = {
    videoData,
    preload: 'none',
    aspectRatio: '4:3',
    poster: posterUrl,
  };

  function getVideoData(type: VideoType, src: string) {
    return;
  }
</script>

<VideoPlayer class={$$restProps.class} {options} />
